import { render, staticRenderFns } from "./PGKategoriComponent.vue?vue&type=template&id=10d91cf4&scoped=true"
import script from "./PGKategoriComponent.vue?vue&type=script&lang=js"
export * from "./PGKategoriComponent.vue?vue&type=script&lang=js"
import style0 from "./PGKategoriComponent.vue?vue&type=style&index=0&id=10d91cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d91cf4",
  null
  
)

export default component.exports